import { useSearchParams } from "react-router-dom"
import { useMemo } from "react"
import qs from "qs"
import { filterNullValue } from "helpers/utils"

function useParamsQuery() {
  const [searchParams, setSearchParams] = useSearchParams()

  const params = useMemo(() => {
    return Object.fromEntries([...searchParams])
  }, [searchParams])

  const setParams = paramsQuery => {
    const result = qs.stringify(filterNullValue(paramsQuery), {
      arrayFormat: "comma",
    })
    setSearchParams(result)
  }

  const addParam = paramQuery => {
    setSearchParams({ ...params, ...paramQuery })
  }
  const getParam = paramName => {
    return params[paramName]
  }

  const deleteParam = paramName => {
    delete params[paramName]
    setSearchParams({ ...params })
  }

  const restParams = () => {
    setSearchParams()
  }

  return {
    params,
    addParam,
    getParam,
    deleteParam,
    setParams,
    restParams,
  }
}

export default useParamsQuery
